import { ImageLabelData } from "@/types/Image.type";
import { PaginationScroll } from "@/types/pagination.type";
import { responseHandlerDefault } from "./../utils/handler.util";
import axios from "./api";
import { Filter } from "@/types/filter.type";

export const getImageLabelHistoryByClassification = (
  classificationId: number,
  samPointId: number,
  page: number,
  size: number,
  startDateTime?: string,
  endDateTime?: string,
  filterImages?: Filter
): Promise<PaginationScroll<ImageLabelData>> => {
  const params: {
    page?: number;
    size?: number;
    startDateTime?: string;
    endDateTime?: string;
    filter?: Filter;
  } = {};

  if (page) {
    params.page = page;
  }
  if (size) {
    params.size = size;
  }
  if (startDateTime) {
    params.startDateTime = startDateTime;
  }
  if (endDateTime) {
    params.endDateTime = endDateTime;
  }

  if (filterImages) {
    params.filter = filterImages;
  }
  return axios
    .get(`/imagelabelhistory/${samPointId}/${classificationId}`, { params })
    .then(responseHandlerDefault);
};
